<template>
  <view-homepage />
</template>

<script setup>
import { onBeforeRouteLeave } from 'vue-router';
import ViewHomepage from '../../../../components/ViewHomepage.vue';

defineOptions({ name: 'Preview' });

definePageMeta({
  middleware: ['preview-auth'],
});

onBeforeRouteLeave((to, from, next) => {
  next(false);
});
</script>
